/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressKitGuidelines,
    PressKitGuidelinesFromJSON,
    PressKitGuidelinesFromJSONTyped,
    PressKitGuidelinesToJSON,
} from './PressKitGuidelines';

/**
 * 
 * @export
 * @interface GetPressKitGuideLinesResponse
 */
export interface GetPressKitGuideLinesResponse {
    /**
     * status code (HTTPと同じ)
     * @type {number}
     * @memberof GetPressKitGuideLinesResponse
     */
    status: number;
    /**
     * ステータスメッセージ。原則英語。
     * @type {string}
     * @memberof GetPressKitGuideLinesResponse
     */
    message: string;
    /**
     * 
     * @type {PressKitGuidelines}
     * @memberof GetPressKitGuideLinesResponse
     */
    data: PressKitGuidelines;
}

export function GetPressKitGuideLinesResponseFromJSON(json: any): GetPressKitGuideLinesResponse {
    return GetPressKitGuideLinesResponseFromJSONTyped(json, false);
}

export function GetPressKitGuideLinesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPressKitGuideLinesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': PressKitGuidelinesFromJSON(json['data']),
    };
}

export function GetPressKitGuideLinesResponseToJSON(value?: GetPressKitGuideLinesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': PressKitGuidelinesToJSON(value.data),
    };
}

